/* eslint-disable object-curly-newline,camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, Form, formValueSelector, propTypes, reduxForm } from 'redux-form';
import { load as loadCostCodesAction } from '../../../../reducers/costCode/costCode.actions';
import { groupedCostCodes as getCostCodes } from '../../../../reducers/costCode/costCode.reducer';
import { load as loadPaymentTypesAction } from '../../../../reducers/paymentTypes/paymentTypes.actions';
import { paymentTypes as getPaymentTypes } from '../../../../reducers/paymentTypes/paymentTypes.reducer';
import { remove as removeAction, save as saveAction } from '../../../../reducers/workOrder/material/material.actions';
import { ErrorAlert } from '../../../ErrorAlert/ErrorAlert';
import SelectFormGroup from '../../../Forms/SelectFormGroup/SelectFormGroup';
import TTFormGroup from '../../../Forms/TTFormGroup/TTFormGroup';
import SpinnerButton from '../../../SpinnerButton/SpinnerButton';
import './MaterialForm.css';
import FileInput from '../../../Forms/FileInput/FileInput';
import S3Item from '../../../S3Item/S3Item';
import { BASE_URL } from '../../../../helpers/api/apiPaths';
import CategorySelectFormGroup from '../../../Forms/CategorySelectFormGroup/CategorySelectFormGroup';

// eslint-disable-next-line object-curly-newline
export class MaterialsForm extends React.Component {
  componentDidMount() {
    this.props.loadCostCodes();
    this.props.loadPaymentTypes();
  }

  render() {
    const { remove, handleSubmit, paymentTypes, currentPaymentTypeId, vendor, costCodes, save, disabled, material: { id, payment_type_id = '', receipt_is_pdf, receipt_url, removing } } = this.props;

    const savedPaymentType = paymentTypes.filter(o => o.id.toString() === payment_type_id.toString());
    const currentPaymentType = paymentTypes.filter(o => o.id.toString() === currentPaymentTypeId);
    const savedValue = savedPaymentType[0] ? savedPaymentType[0].needs_vendor : false;
    const vendorRequired = savedValue || (currentPaymentType[0] ? currentPaymentType[0].needs_vendor : false);
    const onFieldChange = () => setTimeout(handleSubmit(params => save(params)));
    const nonHiddenPaymentTypes = paymentTypes.filter(p => !p.hide);

    return (
      <Form
        onSubmit={() => {
        }}
        onChange={onFieldChange}
      >
        {vendorRequired && !vendor &&
        <Row>
          <Col xs={12} >
            <ErrorAlert>Vendor Name is Required</ErrorAlert>
          </Col>
        </Row>
        }
        <Row>
          <Col sm={4} >
            <Field
              component={SelectFormGroup}
              name="payment_type_id"
              label="Payment Type"
              options={nonHiddenPaymentTypes}
              required
              disabled={disabled}
            />
          </Col>
          <Col sm={4} >
            <Field
              component={TTFormGroup}
              name="price"
              label="Price"
              type="text"
              disabled={disabled}
            />
          </Col>
          <Col sm={4} >
            <Field
              component={CategorySelectFormGroup}
              name="cost_code_id"
              label="Cost Code"
              options={costCodes}
              required
              disabled={disabled}
              onFieldChange={onFieldChange}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6} >
            <Field
              component={TTFormGroup}
              name="vendor"
              label="Vendor"
              type="text"
              disabled={disabled}
              required={vendorRequired}
            />
          </Col>
          <Col sm={6} >
            <Field
              component={TTFormGroup}
              name="no_receipt"
              label="Description (if no receipt)"
              type="text"
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <Row>
              <Col>
                <Field
                  component={FileInput}
                  name="receipt"
                  disabled={disabled}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row sm={12} >
          <Col>
            {receipt_url &&
            <Row>
              <Col>
                <S3Item
                  isPdf={receipt_is_pdf}
                  link={`${BASE_URL}/materials/${id}/receipt`}
                />
              </Col>
            </Row>
            }
          </Col>
        </Row>
        <Row>
          <Col sm={1} >
            <SpinnerButton
              className="removeButton"
              bsStyle="danger"
              onClick={() => remove(id)}
              isLoading={removing}
              disabled={disabled}
            >
              -
            </SpinnerButton>
          </Col>
        </Row>
      </Form>);
  }
}

MaterialsForm.defaultProps = {
  currentPaymentTypeId: null,
  vendor: null,
};

MaterialsForm.propTypes = {
  ...propTypes,
  remove: PropTypes.func.isRequired,
  costCodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentPaymentTypeId: PropTypes.string,
  vendor: PropTypes.string,
  paymentTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadCostCodes: PropTypes.func.isRequired,
  loadPaymentTypes: PropTypes.func.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.material,
  costCodes: getCostCodes(state),
  paymentTypes: getPaymentTypes(state),
  currentPaymentTypeId: formValueSelector(`material${ownProps.material.id}`)(state, 'payment_type_id'),
  vendor: formValueSelector(`material${ownProps.material.id}`)(state, 'vendor'),
  form: `material${ownProps.material.id}`,
});

export const mapDispatchToProps = dispatch => ({
  remove: id => dispatch(removeAction(id)),
  save: values => dispatch(saveAction(values)),
  loadCostCodes: () => dispatch(loadCostCodesAction()),
  loadPaymentTypes: () => dispatch(loadPaymentTypesAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ enableReinitialize: true })(MaterialsForm));



// WEBPACK FOOTER //
// ./src/components/WorkOrder/Materials/MaterialForm/MaterialForm.jsx